import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import "./../styles/styles.css"; 
import { useAuth } from '../context/AuthContext'; // ✅ Import du contexte Auth

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth(); // ✅ Utilisation du hook `login` du contexte Auth

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Veuillez entrer votre email et votre mot de passe.');
      setLoading(false);
      return;
    }

    const API_URL = process.env.REACT_APP_API_URL;


    try {
      const response = await fetch(`${API_URL}/auth/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        console.log('Connexion réussie!', data);

        // Utiliser le contexte pour gérer la connexion
        login(data.token, { userId: data.userId, email: email }); // ✅ Utilisation du contexte Auth pour gérer le login

        // Redirection après login
        navigate('/dashboard');
      } else {
        setError(data.message || 'Erreur lors de la connexion. Veuillez réessayer.');
      }
    } catch (err) {
      console.error('Erreur API :', err);
      setError('Impossible de se connecter au serveur. Veuillez réessayer plus tard.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Se connecter</h2>
        <p className="login-subtitle">Connectez-vous à votre compte pour continuer.</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">Email :</label>
            <input
              type="email"
              id="email"
              placeholder="Votre adresse email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Mot de passe :</label>
            <input
              type="password"
              id="password"
              placeholder="Votre mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
        <div className="login-links">
          <Link to="/forgot-password">Mot de passe oublié ?</Link>
          <p>
            Nouveau sur notre site ?<Link style={{ color: 'blue'}} to="/signup">Créer un compte</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
